import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {FieldDefinitionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {patchJSONPromise, postJSONPromise} from 'util/Net';

export function libraryParameterDefinitionsListingURL(): string {
  return '/library-parameter-definitions/listing';
}

export interface CreateLibraryParameterDefinitionParams {
  name: string;
  unitTypeId: string | null;
  description: string;
  // TODO (BNCH-134420): Add frontend type to alias this
  dataType: FieldDefinitionType.FLOAT | FieldDefinitionType.TEXT;
}

export interface CreateLibraryParameterDefinitionResponse {
  createdIds: Array<string>;
}

export function createLibraryParameterDefinition(
  parameterDefinition: CreateLibraryParameterDefinitionParams
): Promise<CreateLibraryParameterDefinitionResponse> {
  const creates = [parameterDefinition];
  return postJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.LIBRARY_PARAMETER_DEFINITION),
    data: {creates},
  });
}

export interface UpdateLibraryParameterDefinitionParams {
  id: string;
  name?: string;
  description?: string;
}

export interface UpdateLibraryParameterDefinitionResponse {
  updatedIds: Array<string>;
}

export function updateLibraryParameterDefinition(
  parameterDefinition: UpdateLibraryParameterDefinitionParams
): Promise<UpdateLibraryParameterDefinitionResponse> {
  const updates = [parameterDefinition];
  return patchJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.LIBRARY_PARAMETER_DEFINITION),
    data: {updates},
  });
}
